<template><!-- svgo-optimised -->
<svg class="icon icon__chevron icon__chevron--left" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M14.02 16.75 9.07 12l4.95-4.75" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>
</template>